import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLS } from './url.constants';
import { IGetOrder } from '@app/core/models/order.model';
import { ServerMock } from '../mocks/app-serve.mock';
import { environment } from '@environment';
import { REQUEST_GET_ORDER } from '../mocks/app-control.mock';
import { map } from 'rxjs/operators';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class OrderAPI {
  private _httpClient: HttpClient;
  private _localServer: ServerMock = new ServerMock();

  constructor(private _httpBackend: HttpBackend, private _http: HttpClient) {
    this._httpClient = new HttpClient(_httpBackend);
  }

  public getOrderInformation(token: string): Observable<IGetOrder> {
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_GET_ORDER;
    const headers = {
      headers: this._setHeaders(token),
    };
    return production && !isTestServer
      ? this._httpClient.get<IGetOrder>(`${API_URL}${URLS.GET_ORDER}`, headers)
      : this._localServer.request(httpRequest).pipe(
          map((response: HttpResponse<any>) => {
            const orderInfo: IGetOrder = response?.body;
            return orderInfo;
          })
        );
  }

  private _setHeaders(token):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Token: ${token}`,
    };
  }
}
